import { Container } from "@mantine/core"

import { AdminSidebar } from "../AdminSidebar/AdminSidebar"
import { Header } from "../Header/Header"
import { Row, Col } from "../BSReplace"
import "./layout.css"
import type { CurrentLink, NavbarLink } from "shared/src/libs/admin/adminLib.types"

export function Layout({
	headerTitle,
	navbarLink,
	clientId,
	children,
	currentLink,
	badge,
}: Readonly<{
	headerTitle?: string
	navbarLink?: NavbarLink
	clientId?: string
	children?: React.ReactNode
	currentLink: CurrentLink
	badge?: React.ReactNode
}>) {
	const title = headerTitle?.split("#")?.[1] ?? "-"

	return (
		<>
			<SimpleHeader headerTitle={title} badge={badge} />
			<Container fluid>
				<Row className="main-layout">
					<Col sm={2} className="layout-sidebar">
						{navbarLink ? <AdminSidebar navbarLink={navbarLink} clientId={clientId} currentLink={currentLink} /> : null}
					</Col>
					<Col sm={10} className="layout-content">
						{children}
					</Col>
				</Row>
			</Container>
		</>
	)
}

function SimpleHeader({ headerTitle, badge }: Readonly<{ headerTitle?: string; badge?: React.ReactNode }>) {
	return (
		<Header>
			<h4 className="layout-header bs-h4">{headerTitle ?? "HireAra"}</h4>
			{badge}
		</Header>
	)
}
